// Add your custom JS here.

import device from "current-device";
import $ from "jquery";
// home
$(function () {
    if ($( ".home-swiper" ).length) {
        var homeSwiper = new Swiper(".home-swiper", {
            loop: true,
            speed: 1000,
            autoplay : {
                delay:3000
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
        var mainSwiper = new Swiper(".main-swiper", {
            loop:true,
            slidesPerView: "auto",
            spaceBetween: 15,
            centeredSlides: true,
            autoplay : {
                delay:3000
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }
    if ($('.accessories-like-swiper').length){
        var accessoriesLikeSwiper = new Swiper(".accessories-like-swiper", {
            // slidesPerView: 1,
            // spaceBetween: 45,
            // slidesPerGroup: 3,
            loop: true,
            loopFillGroupWithBlank: true,
            breakpoints: {
                767: {
                    slidesPerView: 3,
                    spaceBetween: 45,
                    slidesPerGroup: 3,
                }
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
    let mybutton = document.getElementById("btn-back-to-top");
    window.onscroll = function () {
        console.log(11111)
        scrollFunction();
    };
    function scrollFunction() {
        console.log(22222)
        if (
            document.body.scrollTop > 20 ||
            document.documentElement.scrollTop > 20
        ) {
            mybutton.style.display = "block";
        } else {
            mybutton.style.display = "none";
        }
    }
    mybutton.addEventListener("click", backToTop);
    function backToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }



})
if ($( ".accessories-detail .mySwiper" ).length) {
    var swiper = new Swiper(".mySwiper", {
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(".mySwiper2", {
        spaceBetween: 10,
        thumbs: {
            swiper: swiper,
        },
    });
}



